<template>
  <div style="height: 100%; width: 100%;">
    <div class="sa-flexbox" style="padding-bottom: 20px">
      <div class="sa-flexbox-header">
        <AccettazioneSsnImpegnativaModalComponent @onModificaImpegnativa="onModificaImpegnativa"
          @onAggiungiImpegnativa="onAggiungiImpegnativa" ref="cmpAccettazioneSsnImpegnativaModalComponent"
          :isEdit="true" :idAccettazione="idAccettazione" />
      </div>
      <div class="sa-flexbox-body">
        <div class="b-table-sticky-header">
          <div class="sa-ft-modern-cards-wrapper">
            <div class="sa-ft-modern-card sa-ft-modern-card-default" v-for="i in 10" :key="i">
              <div class="sa-ft-grid">
                <div class="sa-ft-field-normal flex-minimal">
                  <div class="sa-ft-data">
                    <span class="sa-ft-data-value text-center">PVT</span>
                    <span class="sa-ft-data-value" style="font-size: 2.0rem; line-height: 1;">📄</span>
                  </div>
                </div>
                <div class="sa-ft-field-normal flex-auto">
                  <div class="sa-ft-data">
                    <label class="sa-ft-data-label">NRE</label>
                    <span class="sa-ft-data-value">123456789123456</span>
                  </div>
                </div>
                <div class="sa-ft-field-normal flex-1 text-center">
                  <div class="sa-ft-data">
                    <label class="sa-ft-data-label">Priorità</label>
                    <span class="sa-ft-data-value"> <span class="sa-ft-badge primary">
                        P
                      </span></span>
                  </div>
                </div>
                <div class="sa-ft-field-normal flex-1 text-center">
                  <div class="sa-ft-data">
                    <label class="sa-ft-data-label">Stato</label>
                    <span class="sa-ft-data-value">
                      <span class="sa-ft-badge primary">
                        EROGATA
                      </span>
                    </span>
                  </div>
                </div>
                <div class="sa-ft-field-normal flex-1 text-center">
                  <div class="sa-ft-data">
                    <label class="sa-ft-data-label">N.Prestazioni</label>
                    <span class="sa-ft-data-value">
                      <span class="sa-ft-badge primary">
                        2
                      </span>
                    </span>
                  </div>
                </div>
                <div class="sa-ft-field-normal flex-1 text-center">
                  <div class="sa-ft-data">
                    <label class="sa-ft-data-label">Cod.Esenzione</label>
                    <span class="sa-ft-data-value">
                      <span class="sa-ft-badge primary">
                        01300L
                      </span>
                    </span>
                  </div>
                </div>
                <div class="sa-ft-field-normal flex-1 text-end">
                  <div class="sa-ft-data">
                    <div style="gap: 8px;" class="d-flex justify-content-md-end justify-content-between">
                      <b-button v-b-tooltip.hover size="sm" variant="outline-primary" @click="onClickGestisciRicetta"
                        title="Gestisci Ricetta" class="rounded-circle sa-ft-floating-btn secondary">
                        <b-icon icon="clipboard"></b-icon>
                      </b-button>
                      <b-button v-b-tooltip.hover size="sm" variant="outline-primary" title="Visualizza Ricetta"
                        class="rounded-circle sa-ft-floating-btn primary">
                        <b-icon icon="eye"></b-icon>
                      </b-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-modal ref="mdlPrestazioni" title="Prestazioni">
        <b-row v-if="ricettaSelezionata.prestazioni" style="display: flex; justify-content: center">
          <b-col cols="12" style="text-align: center; margin-bottom: 5px"> <span class="font-weight-bold"
              style="font-size: large"> Appuntamento/i Selezionato/i</span> <br /> </b-col>
          <b-col v-for="(selezione, index) in ricettaSelezionata.prestazioni" :key="index" cols="auto"
            style="margin: 1px; text-align: center">
            <b-card class="ft-card" style="height: 100%; width: 100%" v-for="appuntamento in selezione.appuntamenti"
              :key="appuntamento.id">
              <b-card-text style="text-align: center; align-items: center">
                <div class="font-weight-bold" style="font-size: medium">{{ appuntamento.titolo }}</div>
                <div class="font-weight-bold" style="font-size: small">{{ appuntamento.descrizionePrestazione }}</div>
                <div class="font-weight-bold" style="font-size: large">{{ appuntamento.dataRiferimento }}</div>
                <div class="font-weight-bold" style="font-size: medium">{{ getOrario(appuntamento.dataOraInizio) }} - {{
                  getOrario(appuntamento.dataOraFine) }}</div>
              </b-card-text>
            </b-card>
          </b-col>
        </b-row>
      </b-modal>
    </div>
  </div>
</template>
<script>
// import DatePicker from "vue2-datepicker";
import UtilityMixin from "../../../utility/UtilityMixin";
import AccettazioneSsnImpegnativaModalComponent from "./AccettazioneSsnImpegnativaModalComponent1.vue";
import moment from "moment";
// import axios from "axios";
// DatePicker
export default {
  components: { AccettazioneSsnImpegnativaModalComponent },
  mixins: [UtilityMixin],
  props: {},

  data() {
    return {
      ricette: [],
      localData: {
        accettazioneAnagrafica: {
          codiceFiscalePaziente: "",
        },
      },
      idAccettazione: "",
      ricettaSelezionata: {
        prestazioni: [],
      },
      perPage: 10,
      currentPage: 1,
      listKey: 0,
      rows: 0,
      headersImpegnative: [
        {
          label: "Tipologia",
          key: "tipologiaRicetta",
        },
        {
          label: "Priorità",
          key: "classePriorita",
        },
        {
          label: "NRE",
          key: "nre",
        },
        {
          label: "Stato Ricetta",
          key: "statoAttuale",
        },
        {
          label: "Quantita",
          key: "prestazioni",
        },
        {
          label: "",
          key: "actions",
          tdClass: "text-right",
        },
      ],
      rowRicettaDaModificare: null,
    };
  },

  computed: {},
  mounted() {
    console.log(this.idAccettazione);
  },

  watch: {
    currentPage: (v) => {

      console.log(v);


    }
  },
  methods: {
    init(jsonData) {
      if (this.idAccettazione != "-1") {
        this.localData = jsonData;
        this.loadRicette();
      }
    },
    getOrario(data) {
      return moment(data).format("HH:mm");
    },
    getDataSistoFormat(data) {
      let date = new Date(data);
      return moment(date).format("DD-MM-YYYY");
    },
    loadRicette() {
      if (this.idAccettazione) {
        UtilityMixin.methods.loadDataResources("/accettazionericette", { idAccettazione: this.idAccettazione }, this.loadRicetteSuccess, this.loadRicetteError);
      }
    },
    loadRicetteSuccess(response) {
      this.ricette = response.data.data.list;
      this.rows = response.data.data.recordsNumber;
    },
    loadRicetteError(err) {
      err;
    },
    getLocalData() {
      return this.localData;
    },
    onClickNuovaRicetta() {
      this.$refs.cmpAccettazioneSsnImpegnativaModalComponent.init(this.localData);
    },
    onClickModificaRicetta(row) {
      console.log(row);
      this.rowRicettaDaModificare = row;
      this.$refs.cmpAccettazioneSsnImpegnativaModalComponent.setRicettaModificare(this.rowRicettaDaModificare);
      this.$refs.cmpAccettazioneSsnImpegnativaModalComponent.show();
    },
    onClickStorico(row) {
      console.log(row);
      row.toggleDetails();
    },
    onClickRimuoviRicetta(row) {
      this.$bvModal
        .msgBoxConfirm("Sei sicuro di eliminare questo record non sarà più recuperabile  '" + row.item.codiceBar1 + " " + row.item.codiceBar2 + " ?", {
          title: "Eliminazione Ricetta",
          buttonSize: "sm",
          okTitle: "SI",
          cancelTitle: "NO",
          okVariant: "danger",
          cancelVariant: "secondary",
          hideHeaderClose: true,
          footerClass: "p-2",
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.deletePopRicetta(row);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    deletePopRicetta(row) {
      if (row.item.id) {
        this.deleteRicetta(row.item.id);
      } else {
        this.ricette.splice(row.index, 1);
      }
    },
    deleteRicetta(id) {
      console.log(id);
    },
    onAggiungiImpegnativa(ricetta) {
      this.ricette.push(JSON.parse(JSON.stringify(ricetta)));
      this.salvaRicetta(ricetta);
    },
    salvaRicetta(ricetta) {
      ricetta.idAccettazione = this.idAccettazione;
      UtilityMixin.methods.restCallPost(process.env.VUE_APP_PATH_API + "/accettazionericette", ricetta, this.onSalvaRicettaSuccess, this.onSalvaRicettaError);
    },
    onSalvaRicettaSuccess(response) {
      response;
    },
    onSalvaRicettaError(err) {
      err;
    },
    onModificaImpegnativa(ricetta, index) {
      let newItem = JSON.parse(JSON.stringify(ricetta));
      if (ricetta.id) {
        this.modificaRicetta(ricetta);
      } else {
        this.ricette.splice(index, 1, newItem);
      }
    },
    modificaRicetta(ricetta) {
      ricetta.idAccettazione = this.idAccettazione;
      UtilityMixin.methods.restCallPut(process.env.VUE_APP_PATH_API + "/accettazionericette/" + ricetta.id, ricetta, this.onModificaRicettaSuccess, this.onModificaRicettaError);
    },
    onModificaRicettaSuccess(response) {
      response;
    },
    onModificaRicettaError(err) {
      err;
    },
    onClickVisualizzaPrestazioni(row) {
      this.ricettaSelezionata = row.item;
      this.$refs.mdlPrestazioni.show();
    },
  },
};
</script>

<style scoped></style>
